import { Box } from "@mui/material"
import { useParams } from "@tanstack/react-router"
import type { ChangeEvent, FC } from "react"

import { useProductInventoryContext } from "../../contexts"
import { useProductInventoryTransactionList } from "../../hooks"

import { ProductInventoryTransactionsTable } from "./ProductInventoryTransactionsTable"

import SearchInput from "@/components/SearchInput/SearchInput"

export const ProductInventoryTransactionsTab: FC = () => {
  const { productId } = useParams({ from: "/app/inventory/products/$productId/_layout/transactions" })
  const { product } = useProductInventoryContext()

  const {
    transactions,
    isFetching,
    error,
    sorting,
    searchParams,
    tableContainerRef,
    handleSortingChange,
    handleSearchChange,
    handleScroll,
  } = useProductInventoryTransactionList({ productId: Number(productId) })

  return (
    <Box className='flex h-full flex-col gap-y-6'>
      <SearchInput
        placeholder='Search by Customer, Company ID or Order #'
        defaultValue={searchParams.query}
        onChange={(e: ChangeEvent<HTMLInputElement>) => handleSearchChange(e.target.value)}
        className='w-full max-w-[524px]'
        data-testid='product-inventory.transactions-tab.search-field'
      />
      <Box className='flex min-h-0 flex-1 overflow-y-auto'>
        <ProductInventoryTransactionsTable
          product={product}
          data={transactions}
          loading={isFetching}
          error={error}
          sorting={sorting}
          containerRef={tableContainerRef}
          onSortingChange={handleSortingChange}
          onScroll={handleScroll}
        />
      </Box>
    </Box>
  )
}
